import { Mark } from 'slate'
import { ITALIC_MARK } from './markTypes'

export default function ItalicMark() {
  return Mark.create({
    type: ITALIC_MARK
  })
}
